import React from 'react';
import {render} from 'react-dom';
import 'babel-polyfill';

import App from './containers/App';

render(
  <App/>, document.getElementById('app')
);




/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/index.js
 **/